import React, { Suspense } from 'react'
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import { useClientUser } from 'contexts/ClientUserProvider'
import { useSelector } from 'react-redux'
import { useMount } from 'ahooks';
import FullScreenSpinner from 'components/FullScreenSpinner'
import './scss/style.scss'

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/login'))

export default function App() {
  const { isLoggedIn } = useClientUser();
  const storedTheme = useSelector((state) => state.theme)

  useMount(() => {
    // Theme handling can be implemented later with Chakra UI theme system
    console.log('App mounted, theme:', storedTheme)
  });

  return (
    <BrowserRouter>
      <Suspense fallback={<FullScreenSpinner open />}>
        {isLoggedIn ? 
          <Routes>
            <Route path="*" element={<DefaultLayout />} />
            <Route path="/" element={<Navigate to="dashboard" replace />} />
          </Routes>    
        :
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        }
      </Suspense>
    </BrowserRouter>
  )
}